import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import {useParams} from 'react-router-dom'
import Button from '@material-ui/core/Button'

import messages from '../../../../../../../assets/messages'
import {ManagerOffer} from '../../useOffers'
import {config} from '../../../../../../../config'
import {WithCopyToClipboard} from '../../../../../../Common/WithCopyToClipboard'
import {useStyles} from './styles'
import {OfferBody} from './components/OfferBody'
import {PammOfferType} from '../../../../../../../graphql/types'

type OfferTileProps = {
  offer: PammOfferType
} & WithNamespaces

export const mapIntervalNameToI18nKeyPlural: Record<
  ManagerOffer['settings']['tradingInterval']['type'],
  {i18nKey: string; defaults: string}
> = {
  Days: messages.days,
  Weeks: messages.weeks,
  Months: messages.months,
  CalendarMonths: messages.calendarMonths,
}

export const mapIntervalNameToI18nKeySingular: Record<
  ManagerOffer['settings']['tradingInterval']['type'],
  {i18nKey: string; defaults: string}
> = {
  Days: messages.day,
  Weeks: messages.week,
  Months: messages.month,
  CalendarMonths: messages.calendarMonth,
}

const _OfferTile = ({offer}: OfferTileProps) => {
  const classes = useStyles()
  const params = useParams<{accountId?: string}>()
  const {id: offerId, name, activeInvestmentCount} = offer
  const joinLink = `${config.frontendUrl}?pammManager=${params.accountId}&pammOffer=${offerId}`

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.headerTitle}>
          <div className={classes.headerTitleName}>{name}</div>
          <div className={classes.headerTitleInvestors}>
            <Trans {...messages.investors} values={{activeInvestmentCount}} />
          </div>
        </div>
        <div>
          <WithCopyToClipboard text={joinLink}>
            <Button variant="contained" color="primary">
              <Trans {...messages.copyLink} />
            </Button>
          </WithCopyToClipboard>
        </div>
      </div>

      <div className={classes.divider} />

      <OfferBody offer={offer} />
    </div>
  )
}

export const OfferTile = withNamespaces()(_OfferTile)
